export class ModificacionEstadoDTO{
    id: string;
    estadoFinal: number;
    motivoRechazo: string;
    modificacionesCuentas: ModificacionEstadoDTO[]
}